import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToSection, useLandingActions } from "./useLandingActions";

export default function FinalFooter() {
    const { signIn } = useLandingActions();
    return <>
        <section className="mz-final-cta">
            <div className="mz-container"><div>
                <span className="mz-section-label">Start Where You Need</span>
                <h2>Learn more. Gain experience.<br />Test yourself.</h2>
                <p>Choose the program that helps you most today. There is no required order and no prerequisite between MockZo workshops, internships and mock interviews.</p>
                <div className="mz-final-cta__actions">
                    <button className="mz-button mz-button--primary mz-button--large" onClick={signIn}>Getting started <ArrowRight /></button>
                </div>
            </div></div>
        </section>
        <footer className="mz-footer">
            <div className="mz-container">
                <div className="mz-footer__grid">
                    <div><button className="mz-brand" onClick={() => scrollToSection("home")}><img src="/images/jpg/mockzo-logo-v3.webp" alt="" aria-hidden="true" className="mz-brand__mark" /><span>MockZo</span></button><p>Practical career readiness through knowledge, experience and evaluation.</p></div>
                    <div><h3>Programs</h3><button onClick={() => scrollToSection("programs")}>Workshops</button><button onClick={() => scrollToSection("programs")}>Internships</button><button onClick={() => scrollToSection("programs")}>Mock Interviews</button></div>
                    <div><h3>Explore</h3><button onClick={() => scrollToSection("resources")}>Career Resources</button><button onClick={() => scrollToSection("stories")}>Student Stories</button><button onClick={() => scrollToSection("faq")}>FAQ</button></div>
                    <div><h3>Company</h3><button onClick={() => scrollToSection("contact")}>Contact</button><button onClick={signIn}>Sign In</button><Link to="/privacy">Privacy</Link><Link to="/terms">Terms</Link></div>
                </div>
                <p className="mz-footer__copy">© {new Date().getFullYear()} MockZo. All rights reserved.</p>
            </div>
        </footer>
    </>;
}
